import type { AgentReport, AgentCheckResult } from './AgentResult';
import { calculerBulletin } from '@domain/paie/CalculBulletin';
import { calculerParts } from '@domain/paie/PartsFiscales';
import { createSalarieFixtureForAgent } from './fixtures';

/**
 * Agent Tests : vérifie les formules métier sur des cas de référence.
 * Tout échec ici est un bug critique du moteur.
 */
export class AgentTests {
  static readonly NAME = 'Tests unitaires';

  static run(): AgentReport {
    const start = performance.now();
    const r: AgentCheckResult[] = [];

    // Parts fiscales
    r.push(
      this.check(
        'Parts celibataire',
        calculerParts({ situation: 'celibataire', enfants: 0 }) === 1,
      ),
    );
    r.push(
      this.check(
        'Parts marie + 2 enfants = 3',
        calculerParts({ situation: 'marie', enfants: 2, conjoint_actif: false }) === 3,
      ),
    );
    r.push(
      this.check(
        'Parts plafonnées a 5',
        calculerParts({ situation: 'marie', enfants: 8, conjoint_actif: false }) === 5,
      ),
    );

    // Bulletin cadre 500K — CNSS pat 18 % / CNAMGS sal 2 % (CFP 0,50 % et FNH 2 % appliquées, FGTLS désactivée)
    const bul = calculerBulletin(createSalarieFixtureForAgent(), { salaire_base: 500_000 });
    r.push(
      this.check('Bulletin CNSS patronal (18%)', bul.cnss_pf_emp + bul.cnss_rp_emp + bul.cnss_vid_emp === 90_000),
    );
    r.push(this.check('Bulletin CNSS prestations familiales (5%)', bul.cnss_pf_emp === 25_000));
    r.push(this.check('Bulletin CNSS AT-MP (2%)', bul.cnss_rp_emp === 10_000));
    r.push(this.check('Bulletin CNSS VID employeur (11%)', bul.cnss_vid_emp === 55_000));
    r.push(this.check('Bulletin CNAMGS salariale (2%)', bul.cnamgs_sal === 10_000));
    r.push(this.check('Bulletin TCS (5% sur excédent du seuil TCS 150 000)', bul.tcs === 15_750));
    r.push(this.check('Total charges patronales (CNSS + CNAMGS + CFP + FNH ; FGTLS désactivée)', bul.total_charges_emp === 123_000));
    r.push(this.check('Cout employeur = brut + charges', bul.cout_employeur === 623_000));

    return { agentName: this.NAME, results: r, durationMs: performance.now() - start };
  }

  private static check(test: string, passed: boolean): AgentCheckResult {
    return passed ? { test, level: 'ok', msg: 'OK' } : { test, level: 'fail', msg: 'Test echoue' };
  }
}
